import i18n from "@/i18n";

const EVENT_NAME = "open_new_gen";

interface IOpenNewGenEventPayload {
  label: string;
  place: string;
}

function openNewGenEvent({ label, place }: IOpenNewGenEventPayload) {
  window.gtag?.("event", EVENT_NAME, {
    site_language: i18n.language.toUpperCase(),
    place,
    menu_block: label,
  });

  window.rdt?.("track", "Custom", { customEventName: EVENT_NAME });
}

export default openNewGenEvent;
